import type { NavigationGuard, NavigationGuardWithThis, RouteRecordRaw } from 'vue-router'

import { useFeatureFlags } from '@/composables/useFeatureFlags'
import useHasPermissionUser from '@/composables/useHasPermissionUser'

// Interruptor maestro de autos (ver flightsGuard en plane.routes.ts). Bloquea el
// acceso por URL a cualquier pantalla de autos aunque no aparezca en el menú.
const carsGuard: NavigationGuard = (_to, _from, next) => {
	const { carsEnabled } = useFeatureFlags()
	if (!carsEnabled) {
		return next({ path: '/error/not-found' })
	}
	return next()
}

/**
 * Mismo gate que `car.form`: el paso 2 es parte del mismo flujo, así que quien
 * no puede crear una solicitud de auto tampoco tiene por qué ver el catálogo.
 */
const requireCarPermission: NavigationGuardWithThis<undefined> = (
	to,
	from,
	next
) => {
	const { hasPermissionUser } = useHasPermissionUser()

	if (hasPermissionUser('create-car', 'App\\Models\\Request')) {
		return next()
	}

	return next({ path: '/error/not-found' })
}

export const carVehicleStepRoute = {
	path: '/services/car/vehicle',
	name: 'car.vehicle',
	component: () => import('@/modules/cars/pages/CarVehicleStep.vue'),
	meta: {
		serviceName: 'Car',
	},
	beforeEnter: [carsGuard, requireCarPermission],
} as RouteRecordRaw

export default {
	path: '/services/car',
	name: 'car.form',
	component: () => import('@/modules/cars/pages/CarForm.vue'),
	meta: {
		serviceName: 'Car',
	},
	// Mismo gate que hotel.availability: la ability `create-car` existe en el
	// backend (ManagerReservePermissionsSeeder) y se asigna a Master, Travel
	// Manager y Supervisor en RolesSeeder.
	beforeEnter: [
		carsGuard,
		(to, from, next) => {
			const { hasPermissionUser } = useHasPermissionUser()

			if (hasPermissionUser('create-car', 'App\\Models\\Request')) {
				return next()
			} else {
				return next({
					path: '/error/not-found',
				})
			}
		},
	],
} as RouteRecordRaw
